import type { IStringTool } from "../core/IStringTool.ts"

/**
 * Input for retrieving a value from a key-value object or dataset-like structure.
 */
interface RecordAttributeInput {
  /** Source object to read from (e.g. dataset or plain record). */
  record: Record<string, any>

  /** Key to look up (without `"data-"` prefix). */
  name: string

  /** Fallback value if both keys are missing. */
  fallback?: any
}

/**
 * Retrieves a value from an object or dataset-like structure.
 * Tries `record[name]` first, then `record["data-" + name]`, or returns fallback.
 */
export default class RecordAttributeTool implements IStringTool<RecordAttributeInput, any> {
  /**
   * @returns Value from the record or fallback.
   */
  process({ record, name, fallback = null }: RecordAttributeInput): any {
    return (
      record[name] ??
      record[`data-${name}`] ??
      fallback
    )
  }
}
